var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-textarea',{ref:"input",staticClass:"xt-myself-textarea",attrs:{"size":"large","placeholder":_vm.placeholder,"auto-size":_vm.autosize},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }